import React from 'react';
import {useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';
import axios from 'axios';
import _ from 'lodash'
import { BASE_URL } from '../Config/Base';

const FoundAddRolemain = () => {
     
    const[details, setDetails] =useState([])
    const[Roletable, setRoletable] =useState([])  
    const[roleAction,setRoleAction] = useState(); 
    const token = JSON.parse(localStorage.getItem('usertoken'));

    const pageSize = 3;

   const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);

    useEffect(()=>{

        getRole();
       
      },[])
    
     /*---Get Roles ----*/
    
    function getRole(){
    
    
        fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
          method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          "Authorization": "Bearer " +`${token}`,
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
    
    
    })
    
              .then(response => response.json())
    
    
                .then(data => {
                 console.log("Role",data)
                 setRoletable(data);
                 setpaginatedPosts(_(data).slice(0).take(pageSize).value());
                  //localStorage.setItem("Data", JSON.stringify(data));
                  localStorage.setItem("paginationDataRole", JSON.stringify(data));    
                });
               }


//   const pageCount = Roletable? Math.ceil(Roletable.length/pageSize) :0;
// // if (pageCount === 1)
// // return null;

// const pages = _.range(1, pageCount+1)

// const pagination =(pageNo)=>{
// setcurrentPage(pageNo);
// const startIndex = (pageNo - 1) * pageSize;
// const paginatedPost = _(Roletable).slice(startIndex).take(pageSize).value();
// setpaginatedPosts(paginatedPost)
// }

    function handlesubmit(){

        let alldata = localStorage.getItem("Data");
        let RoleName= document.getElementById("RoleName").value
        console.log(alldata)
      
        let roledata =  JSON.parse(alldata);
      console.log(roledata)
      
      
        let names = roledata.map((item) => item.roles);
        console.log(names)
      
      
        let result = names.includes(RoleName);  
        console.log("ROLES",result)  
    
     
       if(!RoleName){
    
        document.getElementById("ErrA").innerHTML="Role Required"
       }
       else if(RoleName){
    
        document.getElementById("ErrA").innerHTML=" "

        if(result==true){
          alert('Role Already Exists!')
          // toast.error(" Role Already Exists! ")
         }
         
        if(result==false){
    
        const body ={
      
         Roles:RoleName,
         DeleteStatus:'0'
        }
       console.log(body);
    
    
    
      axios({
    
        method: "POST",
    
        url: `${BASE_URL}/Foundation/FoundationAddRoles`,
        data:body,
        headers: {
          
          'Content-Type': 'multipart/form-data' ,    
          "Authorization": "Bearer " +`${token}`
         
        }
      
      })
     
      .then((response) =>{
        console.log(response.data);
         if(response.data.status === "Success"){
          alert("Role Added Successfully!");
          //  toast.success("Role Added Successfully!", {
          //          position: "top-center",
          //          autoClose: 3200,
          //          hideProgressBar: false,
          //          closeOnClick: true,
          //          pauseOnHover: true,
          //          draggable: true,
          //          progress: undefined,
          //          className: 'toast-message'
          //          });
                   setTimeout(() => {
                       
                         
                      //  window.location.reload();
                      getRole();
                     document.getElementById("Roleform").reset();
    
                   }, 3000);
                 }
                
                })
         
       .catch(error => {
        console.log(error);
         alert(" Add Role failed !")       
         })
     
        }
      }
       }


      function updateRoleAction(Id){
     
        let arr = [];
        let checkboxes = document.querySelectorAll("input[type='checkbox']:checked");
       
       checkboxes.forEach((item)=>{
          arr.push(item.value)
       }) 
    console.log(arr)
     
    
  
        var radioInput = arr.toString();
           
        const body ={
        
          roleAction: radioInput,      
          id:Id     
        
         }
         console.log(body);
        
          axios({          
             method: "POST", 
             url: `${BASE_URL}/Foundation/FoundUpdateRoleAction`,      
            
             data:body,
             headers: {             
               'Content-Type': 'application/json' , 
               "Authorization": "Bearer " +`${token}`   
             }
           
           })
           .then((response) =>{
            console.log(response.data);
            alert("Assigned!");     
            // toast.success("Assigned!");
            getRole() 

             }) 

            }
    
    
      
    
      function handlechange(){
    
        var RoleName= document.getElementById("RoleName").value
       if(!RoleName){
    
        document.getElementById("ErrA").innerHTML="Role Required"
       }
       else if(RoleName){
    
        document.getElementById("ErrA").innerHTML=" "
       }
      }


      function getParticularRole(Id){
   
        // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        
     
      
       const body ={
        
        id:Id
      
       }
       console.log(body);
      
      
        axios({          
           method: "POST", 
           //url: `${BASE_URL}/Tc/EditSection`,      
           url: `${BASE_URL}/Foundation/GetParticularRole`,
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             "Authorization": "Bearer " + `${token}`    
           }
         
         })
         .then((response) =>{
          console.log(response.data);
          setDetails(response.data)
      
           }) 
      
      } 
  

      function ConfirmDelete(Id){
     
        getParticularRole(Id)

        document.getElementById("modalDeleteForm").style.display = "block";
        
      
      }


       //delete btn func
 function DeleteStatus(Id,RoleName){

  // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   const body ={
    id: Id
  }
   console.log(body)
    axios({
   
    method:"POST",
    //url: `${BASE_URL}/Tc/DeleteStatus`,
   url:`${BASE_URL}/Foundation/DeleteRole`,
   data:body,
   headers: {
   "Content-Type" : "application/json",
   "Authorization": "Bearer " + `${token}`
   }
  
    })
    .then((response) =>{
    console.log(response.data);
    //window.location.reload();
    
    if(response.data.status === "Success"){

        alert(RoleName+""+"-"+"Deleted Successfully!");
        // toast.success(RoleName+""+"-"+"Deleted Successfully!");

        closedelForm()
        getRole()
        // setcurrentPage(1);
  
        // setTimeout(() => {        
        //    window.location.reload();
        // }, 5000);
     
    }

    })
 
    } 


    function closedelForm()
    {
       document.getElementById("modalDeleteForm").style.display = "none";
     
     }
    
     function Cancel() {
      document.getElementById("modalDeleteForm").style.display = "none";      
         }


               
         const LEFT_PAGE = "LEFT";
         const RIGHT_PAGE = "RIGHT";
         const range = (from, to, step = 1) => {
           let i = from;
           const range = [];
         
           while (i <= to) {
             range.push(i);
             i += step;
           }
         
           return range;
         };
         const [currentPage, setCurrentPage] = useState(1);

         let data = localStorage.getItem("paginationDataRole")
         let transdata =  JSON.parse(data);
         let NUM_OF_RECORDS = transdata.length;
         let LIMIT = 5;
         
         const onPageChanged = useCallback(
         
           (event, page) => {
             event.preventDefault();
             setCurrentPage(page);
           },
           [setCurrentPage]
           
         );
         
         
         const currentData = transdata.slice(
           (currentPage - 1) * LIMIT,
           (currentPage - 1) * LIMIT + LIMIT
         );
         
         const Paginations = (props) => {
           const {
             totalRecords,
             pageLimit,
             pageNeighbours,
             onPageChanged,
             currentPage
           } = props;
           const [totalPages, setTotalPages] = useState(0);
           useEffect(() => {
             setTotalPages(Math.ceil(totalRecords / pageLimit));
           }, [setTotalPages]);
         
           const fetchPageNumbers = () => {
             const totalNumbers = pageNeighbours * 1 + 0;
             console.log(totalNumbers)
             console.log(pageNeighbours)
             const totalBlocks = totalNumbers + 2;
             console.log(totalBlocks)
         
             if (totalPages > totalBlocks) {
               const startPage = Math.max(2, currentPage - pageNeighbours);
               const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
         
               let pages = range(startPage, endPage);
         
               const hasLeftSpill = startPage > 2;
               const hasRightSpill = totalPages - endPage > 1;
               const spillOffset = totalNumbers - (pages.length + 1);
         
               switch (true) {
                 case hasLeftSpill && !hasRightSpill: {
                   const extraPages = range(startPage - spillOffset, startPage - 1);
                   pages = [LEFT_PAGE, ...extraPages, ...pages];
                   break;
                 }
                 case hasLeftSpill && hasRightSpill:
                 default: {
                   pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                   break;
                 }
               }
               return [1, ...pages, totalPages];
             }
             return range(1, totalPages);
           };
         
         
           const pages = fetchPageNumbers() || [];
           return (
             <nav aria-label="Countries Pagination" id='foundnavpag'>
               <ul className="pagination">
                 {pages.map((page, index) => {
                   if (page === LEFT_PAGE)
                     return (
                       <li key={index} className="page-item">
                         <a
                           href="/"
                           className="page-link"
                           aria-label="Previous"
                           onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                         >
                           <span aria-hidden="true">&laquo;</span>
                         </a>
                       </li>
                     );
         
                   if (page === RIGHT_PAGE)
                     return (
                       <li key={index} className="page-item">
                         <a
                           className="page-link"
                           href="/"
                           aria-label="Next"
                           onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                         >
                           <span aria-hidden="true">&raquo;</span>
                         </a>
                       </li>
                     );
         
                   return (
                     <li
                       key={index}
                       className={`page-item${currentPage === page ? " active" : ""}`}
                     >
                       <a
                         className="page-link"
                         href="/"
                         onClick={(e) => onPageChanged(e, page)}
                       >
                         {page}
                       </a>
                     </li>
                   );
                 })}
               </ul>
             </nav>
           );
         };

 return(
<div className='foundation-addmain'>
<ToastContainer
     id="toast"
     position="top-center"
     autoClose={1500}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
    draggable
    pauseOnHover
    />

    <div className="foundation-addgrid-layout">
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundAdduser'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Add Role</span>
    </div>
    </div>

     {/* Add Role form */}

     <div>
           <div className='foundation-Roletable-section'>
              <form id="Roleform" onSubmit={handlesubmit}>
              <div className="modal-body mx-4">

              <div className='col-sm-12'>
              <div className='row'>

                   <div className='col-sm-10'> 
                  <div className="md-form mb-0">
                    
                     <input type="text" placeholder='Roles' className="form-control validate" id="RoleName" onChange={handlechange}></input>
                     <span id="ErrA" className='error'></span>
                     <span id="Error"></span>
                     </div>
                     </div>

                  {/* <div className="modal-footer d-flex justify-content-center">
                        <button type="submit"  className="foundation-profile-button">CREATE</button>
                  </div> */}

<div className='col-sm-1'> 
<div className="md-form" id='role-create-btn'>
<button type="submit"  className="foundation-AddRole-button mt-2">CREATE</button>
</div>
</div>

                  </div>
                  </div>
                  </div>

           </form>

    </div>
    </div>


       {/* DeletePopup */}

 <div className="foundation-pop-fade" id="modalDeleteForm" tabindex="-1" role="dialog">
 {details.map((e)=>{ 
   return<div className="modal-dialog" role="document">
      <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-0">
            <div className='text-center'>
          <h5>Are you sure want to Delete?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="foundation-deleteuser-button"  onClick={()=>DeleteStatus(e.id,e.roles)} type='submit'>Delete</button>
        <button className="foundation-deleteuser-button"  onClick={Cancel} type='submit'>Cancel</button>
       </div>
       </form>
      
     </div>
    </div>
    })} 
</div>

{/* Table for Role */}

<div className='foundationAddRole-table'>
<div className="table_foundationAddRole-responsive ">

{/* {
  !paginatedPosts ? (" "):( */}
<table>

    <thead>
     <tr>
      <th>Roles</th>
      <th>Actions
       {/* <br></br><br></br>
              <label><input type="checkbox" id='radioInput'onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Add" />Add</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Edit"/>Edit</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Delete"/>Delete</label>&nbsp;&nbsp;&nbsp;&nbsp; */}

      </th>
      <th>AssignedAction</th>
      <th>Delete</th>
     
     </tr>
    </thead>

  <tbody>
  {currentData.map((e)=>
            {
              return<tr>
             <td>{e.roles}</td>
             
             <td style={{whiteSpace:"nowrap"}}> 

              <label><input type="checkbox" id='radioInput'onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Add" />Add</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Edit"/>Edit</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <label><input type="checkbox" id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Delete"/>Delete</label>&nbsp;&nbsp;&nbsp;&nbsp; 
             
             <button  id="Foundcheckboxbtn" onClick={()=>updateRoleAction(e.id)}>Set</button>
             
             </td>

             {!e.roleAction?<td>No Task Assigned</td>:
             <td>{e.roleAction}</td>}
             <td id='ActionData'>

<i className="fa fa-refresh" id='FoundDelicon' onClick={()=>ConfirmDelete(e.id)}></i></td>
          
             </tr>
            })}

  </tbody>

</table>

  {/* )} */}

<br></br>
{transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(

         <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 
          )}
          </div>
}
 
  
   {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav>  */}

</div>
</div>

</div>
    
    )

}

export default FoundAddRolemain
